import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

const ignoredProps = ['hasVisibleList', 'hasHiddenList'];

export const StyledFormContainer = styled(Box, {
  shouldForwardProp: (prop) => !ignoredProps.includes(prop),
})(({ theme, hasVisibleList, hasHiddenList }) => ({
  padding: '0 1.5rem',
  [theme.breakpoints.down('sm')]: {
    padding: 0,
  },
  ...(hasVisibleList && {
    backgroundColor: theme.palette.custom.settings.background,
    width: '70%',
  }),
  ...(hasHiddenList && {
    width: 0,
    height: 0,
    overflow: 'hidden',
  }),
}));
